import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Heading,
  Surface,
} from '@americanexpress/dls-react';
import { IconDocument, IconUpload } from '@americanexpress/dls-icons';
import { RenderModule } from 'holocron';

const LandingPage = ({
  handleLandingPage, labels, accountToken, filePreview, downloadProgress,
}) => (
  <div className="card pad-3-lr-md-up pad-1-lr-sm-down pad-responsive-extra width-full">
    <div className="text-align-center">
      <Heading
        level={1}
        variant="sans-large-book"
        className="pad-3-b"
      >
        <FormattedMessage id="mainHeading" />
      </Heading>

      <p className="body-3 margin-0 pad-3-b">
        <FormattedMessage id="landing1" />
      </p>

      <div className="border-b pad-3-b">
        <IconDocument
          title="Document icon"
          titleId="document-icon-id"
          size="xl"
        />
      </div>

      <div className="margin-auto-l-md-up margin-auto-md-down pad-4-t">
        <Button
          variant="primary"
          icon={<IconUpload title="upload icon" titleId="landing-upload-icon" size="md" />}
          iconPosition="start"
          aria-label={labels.upload}
          onClick={() => handleLandingPage(false)}
          id="btn-submit"
          style={{ paddingLeft: '4rem', paddingRight: '4rem' }}
        >
          {labels.upload}
        </Button>
      </div>
    </div>

    <Surface variant="base" className="pad-4 margin-4-t radius-container">
      <div className="body-1 pad-1-b">
        <RenderModule
          moduleName="axp-document-upload-history"
          props={{
            altDocIdProp: accountToken,
            filePreview,
            downloadProgress,
            processId: 'api_consumer_doccenter_history_access',
            consumerId: 'DOCCENTER',
          }}
        />
      </div>
    </Surface>
  </div>
);

LandingPage.propTypes = {
  handleLandingPage: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    upload: PropTypes.string.isRequired,
  }).isRequired,
  accountToken: PropTypes.string.isRequired,
  filePreview: PropTypes.func.isRequired,
  downloadProgress: PropTypes.instanceOf(Object).isRequired,
};

export default LandingPage;
